export default __webpack_public_path__ + "static/media/spratt12.14efb469.jpg";